var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotCurrentShopIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3501 19.7757C11.1296 20.0078 11.1412 20.3733 11.3733 20.5938C11.4836 20.6983 11.6286 20.7505 11.7737 20.7505C11.9304 20.7505 12.0812 20.6867 12.1973 20.5706L16.8859 15.6093C17.0948 15.383 17.0948 15.0348 16.8859 14.8143L12.1973 9.87043C11.9768 9.63832 11.6112 9.62671 11.3791 9.84722C11.147 10.0677 11.1354 10.4333 11.3559 10.6654L15.1161 14.6286H0.580271C0.261122 14.6286 0 14.8898 0 15.2089C0 15.5281 0.261122 15.7892 0.580271 15.7892H15.1161L11.3501 19.7757Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2205 13.6073L23.4952 9.8588L13.706 0L4.38686 9.12186C4.16055 9.34816 4.15475 9.71373 4.37525 9.94004C4.60156 10.1663 4.96713 10.1721 5.19344 9.95164L13.6944 1.63636L22.5029 10.5087V22.8395H5.80852C5.48937 22.8395 5.22825 23.1006 5.22825 23.4197C5.22825 23.7389 5.48937 24 5.80852 24H23.6635V11.675L26.3965 14.4255C26.5126 14.5416 26.6577 14.5996 26.8085 14.5996C26.9594 14.5996 27.1045 14.5416 27.2147 14.4313C27.441 14.205 27.441 13.8395 27.2147 13.6132L27.2205 13.6073Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotCurrentShopIcon);
export default __webpack_public_path__ + "static/media/not-current-shop-icon.e064bb0d.svg";
export { ForwardRef as ReactComponent };